import React, { useEffect, useState, useCallback } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../components/Loader';
import UserImage from "../../assets/user.png"

const NewChat = () => {
    const [chatFriends, setChatFriends] = useState([])
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
    const [isLoading, setIsLoading] = useState(true)
    const navigate = useNavigate()

    console.log(chatFriends)

    const getFriends = useCallback(async (pageNum) => {
        try {
            // Append page as a query param
            setIsLoading(true)
            const response = await api.get(`chats/friends?page=${pageNum}`)
            setIsLoading(false)
            if (response?.data) {
                const newData = response.data;

                // If the backend returns an empty array, there's no more data
                if (newData.length === 0) {
                    setHasMore(false);
                    return;
                }

                setChatFriends((prev) =>
                    pageNum === 1 ? newData : [...prev, ...newData]
                );

                // Example logic: if backend returns fewer than 10 items, it's the last page
                if (newData.length < 10) {
                    setHasMore(false);
                }
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to load friends");
            setHasMore(false);
            setIsLoading(false);
        }
    }, []);

    // Fetch initial data
    useEffect(() => {
        getFriends(1);
    }, [getFriends]);

    const fetchMoreData = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        getFriends(nextPage);
    };

    const handleRefresh = () => {
        setPage(1);
        setHasMore(true);
        getFriends(1);
    };

    return (
        <div className="new-chat-wrapper">
            <h2 className="section-title">Friends</h2>
            <InfiniteScroll
                dataLength={chatFriends.length}
                next={fetchMoreData}
                hasMore={hasMore}
                loader={<Loader />}
                refreshFunction={handleRefresh}
                pullDownToRefresh={true}
                endMessage={<p style={{ textAlign: 'center' }}>No more friends to show</p>}
            >
                <div className="users-container">
                    {chatFriends.map((frd) => (
                        <div
                            key={frd._id}
                            className="user-card-container"
                            onClick={() => navigate(`/chats/friends/${frd._id}`, { state: { partner: frd } })}
                        >
                            <div className="user-card-profile-image">
                                <img
                                    src={frd?.profilePic?.url || UserImage}
                                    alt={`${frd?.firstname}'s profile`}
                                />
                            </div>
                            <div className="user-profile-name">
                                <h3 className='user-card-name'>
                                    {frd?.firstname} {frd?.lastname}
                                </h3>
                            </div>
                        </div>
                    ))}
                </div>
            </InfiniteScroll>
            {isLoading && <Loader />}
        </div>
    )
}

export default NewChat